<template>
  <div class="myOverlay">
    <div class="popupScrollContainer" >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // onWheel(e) {
      // const el = e.currentTarget;
      // const delta = e.deltaY;
      //
      // // Scroll nach oben/ unten verhindern, wenn am Rand
      // if ((delta > 0 && el.scrollTop + el.clientHeight >= el.scrollHeight) ||
      //   (delta < 0 && el.scrollTop <= 0)) {
      //   e.preventDefault(); // scrollen blocken
      // }
      // // sonst scroll innerhalb des Popups erlauben
    // }
  }
}
</script>

<style scoped lang="scss">
.myOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--layout-width);
  height: var(--layout-height);
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 201;
}

.popupScrollContainer{
  max-height: 93vh;     /* Höhe begrenzen */
  overflow-y: hidden;
  width: 100%;
}

.myPopup {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  max-width: 90%;
  max-height: 90%;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
</style>
